import { Suspense } from 'react';
import { Navigate, Outlet } from 'react-router';

import { useFirebase } from '@/modules/common/application/context/firebase';
import { useUser } from '@/modules/common/application/context/user';
import { roleFallback } from '@/modules/common/application/route-fallback';
import { Loader } from '@/modules/common/components';

const GuestRoute = () => {
  const { authenticated, loading: firebaseLoading } = useFirebase();
  const { user, company, loadingUserData } = useUser();

  if (firebaseLoading || (authenticated && loadingUserData)) return <Loader />;

  if (authenticated)
    return <Navigate to={roleFallback(user?.role, company?.useNewVersion)} replace />;

  return (
    <Suspense fallback={<Loader />}>
      <Outlet />
    </Suspense>
  );
};

export default GuestRoute;
